import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import roleReducer from "./role/roleSlice";
import sessionReducer from "./session/sessionSlice";
import eventLocationReducer from "./eventLocation/eventLocationSlice";
import speakerReducer from "./userSpeaker/userSpeakerSlice";
import loaderReducer from "./loader/loaderSlice";
import notificationReducer from "./notification/notificationSlice";
import ratingReducer from "./ratings/ratingSlice";
import companyCategoryReducer from "./companyCategory/companyCategorySlice";
import sponsorReducer from "./sponsors/sponsorSlice";
import meetingReducer from "./meetings/meetingSlice";
import mediaReducer from "./media/mediaSlice";
import galleryReducer from "./gallery/gallerySlice";
import floorMapReducer from "./floorMap/floorMapSlice";
import helpSosReducer from "./helpSos/helpSosSlice";
import feedbackReducer from "./feedback/feedbackSlice";
import productReducer from "./companyProduct/companyProductSlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import adsReducer from "./ads/adsSlice";
import agendaReducer from "./conferenceAgenda/conferenceAgendaSlice"
import supportReducer from "./support/supportSlice";
import chatRequestReducer from "./chatRequest/chatRequestSlice";
import masterReducer from "./master/masterSlice";
import chatConversationReducer from "./chatConversation/chatConversationSlice";
import contentReducer from "./content/contentSlice";

export const store = configureStore({
  reducer: {
    loader: loaderReducer,
    auth: authReducer,
    role: roleReducer,
    session: sessionReducer,
    eventLocation: eventLocationReducer,
    speaker: speakerReducer,
    notification: notificationReducer,
    rating: ratingReducer,
    companyCategory: companyCategoryReducer,
    sponsor: sponsorReducer,
    meeting: meetingReducer,
    media: mediaReducer,
    gallery: galleryReducer,
    floorMap: floorMapReducer,
    helpSos: helpSosReducer,
    feedback: feedbackReducer,
    products: productReducer,
    dashboard: dashboardReducer,
    ads: adsReducer,
    agenda: agendaReducer,
    support: supportReducer,
    chatRequest: chatRequestReducer,
    master: masterReducer,
    chatConversation: chatConversationReducer,
    content: contentReducer,
  },
});
